// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.likeshop-header[data-v-f9a7fd88]{box-shadow:0 .5px 0 0 #ddd;box-shadow:0 .5px 0 0 var(--border);display:flex;padding:1rem;padding:var(--space-16);justify-content:flex-start}@media (min-width:768px){.likeshop-header[data-v-f9a7fd88]{justify-content:center}[data-v-f9a7fd88]:root{--media-gap:var(--space-8)}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
